import React, { createContext } from 'react';

export type HandleTechnicalError = (
  errorMessage: string,
  isEvent: boolean,
  suppressTealiumEvent: boolean,
) => void;

type TechnicalErrorContextType = {
  handleTechnicalError: HandleTechnicalError;
};

export const TechnicalErrorContext = createContext<TechnicalErrorContextType | null>(null);

type TechnicalErrorProviderProps = {
  handleTechnicalError: (
    errorMessage: string,
    isEvent: boolean,
    suppressTealiumEvent: boolean,
  ) => void;
  children: React.ReactNode;
};

export function TechnicalErrorProvider({
  handleTechnicalError,
  children,
}: TechnicalErrorProviderProps) {
  return (
    <TechnicalErrorContext.Provider value={{ handleTechnicalError }}>
      {children}
    </TechnicalErrorContext.Provider>
  );
}
